var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unknown",attrs:{"data-testid":"unknown"}},[_vm._v("\n  Component "+_vm._s(_vm.resource.resource_class_name)+" not registered.\n  "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }